<!-- <mat-tab-group color="accent" (selectedTabChange)="onChangeTab($event)">
  <mat-tab [label]="'Authentication' | translate">
    <mat-card class="faqs__content-card">
      <app-table
        [dataSourceInput]="dataSourceAuth"
        [displayedColumns]="displayedColumns"
        (onChangeToggleEmitter)="onChangeToggle($event)"
      >
      </app-table>
    </mat-card>
  </mat-tab>

  <mat-tab [label]="'Signature' | translate">
    <mat-card class="faqs__content-card">
      <app-table
        [dataSourceInput]="dataSourceSignature"
        [displayedColumns]="displayedColumns"
        (onChangeToggleEmitter)="onChangeToggle($event)"
      >
      </app-table>
    </mat-card>
  </mat-tab>

  <mat-tab [label]="'Request' | translate">
    <mat-card class="faqs__content-card">
      <app-table
        [dataSourceInput]="dataSourceRequest"
        [displayedColumns]="displayedColumns"
        (onChangeToggleEmitter)="onChangeToggle($event)"
      >
      </app-table>
    </mat-card>
  </mat-tab>

  <mat-tab [label]="'Administration' | translate">
    <mat-card class="faqs__content-card">
      <app-table
        [dataSourceInput]="dataSourceAdmin"
        [displayedColumns]="displayedColumns"
        (onChangeToggleEmitter)="onChangeToggle($event)"
      >
      </app-table>
    </mat-card>
  </mat-tab>
</mat-tab-group>-->

<mat-tab-group (selectedTabChange)="onChangeTab($event)">
  <mat-tab label="AlertTab">
    <mat-card class="faqs__content-card">
      <mat-card-subtitle>Authentication</mat-card-subtitle>
      <app-table
        [dataSourceInput]="dataSourceAuth"
        [displayedColumns]="displayedColumns"
        (onChangeToggleEmitter)="onChangeToggle($event, 'Authentication')"
      >
      </app-table>
      <br /><br />

      <mat-card-subtitle>Signature</mat-card-subtitle>
      <app-table
        [dataSourceInput]="dataSourceSignature"
        [displayedColumns]="displayedColumns"
        (onChangeToggleEmitter)="onChangeToggle($event, 'Signature')"
      >
      </app-table>
      <br /><br />

      <mat-card-subtitle>Request</mat-card-subtitle>
      <app-table
        [dataSourceInput]="dataSourceRequest"
        [displayedColumns]="displayedColumns"
        (onChangeToggleEmitter)="onChangeToggle($event, 'Request')"
      >
      </app-table>
      <br /><br />

      <mat-card-subtitle>Administration</mat-card-subtitle>
      <app-table
        [dataSourceInput]="dataSourceAdmin"
        [displayedColumns]="displayedColumns"
        (onChangeToggleEmitter)="onChangeToggle($event, 'Administration')"
      >
      </app-table>
    </mat-card>
  </mat-tab>
  <mat-tab label="JobsTab">
    <mat-card class="faqs__content-card">
      <app-table
        [dataSourceInput]="dataJob"
        [displayedColumns]="displayedColumnsJobs"
        (onChangeToggleEmitter)="onChangeToggle($event, 'Jobs')"
      >
      </app-table>
    </mat-card>
  </mat-tab>
</mat-tab-group>
